module.exports = __webpack_public_path__ + "img/staff-2018-gugong.1699d79e.jpg";